import { render, staticRenderFns } from "./DetalheProduto.vue?vue&type=template&id=3228a68f&"
import script from "./DetalheProduto.vue?vue&type=script&lang=js&"
export * from "./DetalheProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports